import { Component, OnInit } from '@angular/core'

@Component({
  selector: 'app-check-symbol',
  templateUrl: './check-symbol.component.html',
  styleUrls: ['./check-symbol.component.scss']
})
export class CheckSymbolComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/common-component/check-symbol/check-symbol.component.ts